import React from 'react';
import { constants, getSpecificClientConfig } from 'redux/modules/client-config/selectors';
import { QuoteQuoteSectionWithPriceSuggestion } from './QuoteQuoteSectionWithPriceSuggestion';
import { QuoteQuoteSectionWithNoPriceSuggestion } from './QuoteQuoteSectionWithNoPriceSuggestion';
import { useSelector } from 'react-redux';

export const QuoteQuoteSection = ({ quoteFormBodyData }) => {
  const showPriceSuggestion =
    useSelector((state) =>
      getSpecificClientConfig(state, constants.EMERGENCIES_SHOW_PRICE_SUGGESTION)
    ) === true;
  return showPriceSuggestion ? (
    <QuoteQuoteSectionWithPriceSuggestion quoteFormBodyData={quoteFormBodyData} />
  ) : (
    <QuoteQuoteSectionWithNoPriceSuggestion quoteFormBodyData={quoteFormBodyData} />
  );
};
